import { isEmail } from '@albacross/frontend-utils'

export const userEditValidator = values => {
  const errors: Record<string, any> = {}

  if (!values.first_name) errors.first_name = 'First name is required'

  if (!values.last_name) errors.last_name = 'Last name is required'

  if (!isEmail(values.email)) errors.email = 'E-mail is invalid'

  if (!values.email) errors.email = 'E-mail is required'

  return errors
}
